var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromisedToPay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2319_21843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.897 26.9647L29.6862 26.9532V27.1644V30.6497L28.3361 30.3458L25.9661 26.8299L25.9102 26.747L25.8104 26.742L7.89919 25.8346C7.07413 25.7928 6.32879 25.3289 5.92691 24.6071C5.68996 24.1816 5.58834 23.6939 5.63559 23.2091L6.76897 11.5802C6.98007 9.41435 8.69704 7.70215 10.8635 7.49708L32.2891 5.46897C32.506 5.44844 32.7241 5.44354 32.9417 5.45429L34.5323 5.5329C34.6748 5.53994 34.8157 5.56551 34.9516 5.60897C35.6319 5.82657 36.0936 6.45894 36.0936 7.17321V22.5038C36.0936 25.1106 33.9051 27.1831 31.3021 27.0412L29.897 26.9647Z",
    fill: "#EBEEF2",
    stroke: "#6AC5AB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2061 26.5616L27.9953 26.5501V26.7613V30.0245L24.2485 26.395L24.1949 26.343L24.1202 26.339L9.75547 25.5562C7.34543 25.4249 5.45854 23.4324 5.45854 21.0187V11.6709C5.45854 9.29085 7.29499 7.31403 9.66861 7.13903L29.5244 5.67516C32.1585 5.48096 34.4027 7.56574 34.4027 10.207V22.1007C34.4027 24.7076 32.2142 26.78 29.6112 26.6382L28.2061 26.5616Z",
    fill: "white",
    stroke: "#6AC5AB",
    strokeWidth: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7584 13.0525L25.8364 12.9077C26.0494 12.9077 26.2237 13.0978 26.2237 13.3321L26.2251 21.0272C26.2251 21.2614 26.0515 21.4516 25.8378 21.4516L23.7584 21.2413C23.5446 21.2413 23.371 21.0511 23.371 20.8169V13.4769C23.371 13.2426 23.5454 13.0525 23.7584 13.0525Z",
    fill: "#6AC5AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6245 13.5809C15.6818 13.5702 18.4166 13.4052 18.4166 13.4052L18.0419 12.2776C17.7833 11.4989 17.9507 10.3098 18.6681 9.88704C18.9016 9.74938 19.228 9.68024 19.4911 9.7533C19.6419 9.79518 19.7745 9.90537 19.8536 10.053C19.9445 10.2228 19.9351 10.421 19.9675 10.6093C20.0495 11.0868 20.2541 11.5408 20.5709 11.8816C21.1232 12.4758 22.8389 13.4052 22.8389 13.4052V20.6762L16.91 20.4684C16.11 20.469 15.5857 19.4835 15.9803 18.7137C15.5099 18.3814 15.3491 17.6815 15.6245 17.1441C15.1542 16.8118 14.9933 16.1119 15.2688 15.5745C14.5603 14.9694 14.6763 13.7578 15.6245 13.5809Z",
    fill: "#6AC5AB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2319_21843",
    x: 0.0399499,
    y: 0.97902,
    width: 40.5233,
    height: 35.1393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.474418,
    dy: 0.474418
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.37209
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2319_21843"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2319_21843",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromisedToPay);
export default __webpack_public_path__ + "static/media/promised_to_pay.fa193b13e9d8d41e02e997bdce518602.svg";
export { ForwardRef as ReactComponent };